<lib-input-wrapper [ionItemWrap]="ionItemWrap">
    <p *ngIf="label" class="ion-no-margin input-label">{{ label }}</p>
    <div class="flex" [formGroup]="form">
        <lib-select
            [form]="form"
            controlName="day"
            [options]="days"
            class="full-width"
            placeholder="Day"
            (selectChange)="onSelectChange($event, 'day')"
            [ionItemWrap]="false"
            [addBottomMargin]="false"
            [enableOptionsMaxHeight]="true"
            [required]="required" />

        <div class="margin-horizontal-small full-width">
            <lib-select
                [form]="form"
                controlName="month"
                [options]="months"
                class="full-width"
                placeholder="Month"
                (selectChange)="onSelectChange($event, 'month')"
                [ionItemWrap]="false"
                [addBottomMargin]="false"
                [enableOptionsMaxHeight]="true"
                [required]="required" />
        </div>
        <lib-select
            [form]="form"
            controlName="year"
            [options]="years"
            class="full-width"
            placeholder="Year"
            (selectChange)="onSelectChange($event, 'year')"
            [ionItemWrap]="false"
            [addBottomMargin]="false"
            [enableOptionsMaxHeight]="true"
            [required]="required" />
    </div>
    <div class="invalid-text" *ngIf="errorText">
        <p>{{ errorText }}</p>
    </div>
</lib-input-wrapper>
